/**
 * 分享数据
 * @param newData
 * @returns {{title: (*|string), content: (*|string), url: (*|string), picPath: string, waImg: string, twoDimensionCodeX: number, twoDimensionCodeY: number, twoDimensionCodeW: number, twoDimensionCodeColor: string, color: string, panelType: string, posterPicPath: *, wechatZonePic: *, miniAppShare: {title: (*|string), content: (*|string), appId: string, path: string, pic: string}}}
 * @private
 */
import native from '@zz-common/native-adapter/es/all'
import AXIOS from '@lib/axios.js'
import DomainMaps from '@/maps/domainMaps'

const __getShareData = function (newData) {
  const pic =
    newData.pic || 'https://pic3.zhuanstatic.com/zhuanzh/n_v2bba756af71bd45a6913ea9da62d84f14.png'
  const url = newData.url
  const title = newData.title || '采货侠'
  const content = newData.content || '你竟然还不知道！这里采货巨便宜！快来看看 >>'
  const miniAppShare = newData.miniAppShare
  return {
    miniAppShare,
    title,
    content,
    url,
    picPath: pic,
    waImg: newData.waImg || pic,
    twoDimensionCodeX: 200,
    twoDimensionCodeY: 200,
    twoDimensionCodeW: 200,
    twoDimensionCodeColor: '#00ff00',
    color: '#FB5329',
    panelType: 'onlyWeixin',
    posterPicPath: newData.wechatZonePic,
    wechatZonePic: newData.wechatZonePic
  }
}
const __getSharePosterData = function (newData) {
  const title = newData.title
  const url = newData.url
  const nowPrice = newData.nowPrice
  const miniQrCodePicUrl = newData.miniQrCodePicUrl
  return {
    methodName: 'setRightShareButton',
    title: title,
    content: title,
    picPath: 'https://pic3.zhuanstatic.com/zhuanzh/n_v22c00c25046e5474795382bba42fae307.png',
    url: url,
    panelType: 'onlyWeixin',
    shareType: 'common',
    needLogin: 0,
    goodsInfo: {
      // 端内分享微信好友用的图
      pics: 'https://pic3.zhuanstatic.com/zhuanzh/n_v22c00c25046e5474795382bba42fae307.png',
      title: title,
      infoId: '0',
      oriPrice: '0',
      nowPrice: nowPrice
    },
    shareParam: {
      isMiniApp: '1',
      miniAppTitle: title,
      miniPath: `/pages/webview/bridge?url=${encodeURIComponent(url)}`,
      smallPicUrl: 'https://pic3.zhuanstatic.com/zhuanzh/n_v22c00c25046e5474795382bba42fae307.png',
      // 海报二维码图片
      miniQrCodePicUrl: miniQrCodePicUrl,
      miniAppId: 'gh_3099e8332566'
    },
    callback: ''
  }
}
const setSharePoster = function (newData = {}, callback) {
  const defaultData = __getSharePosterData(newData)
  native.share(defaultData, callback)
  return defaultData
}
const setShare = function (newData = {}, callback) {
  const defaultData = __getShareData(newData)
  native.share(defaultData, () => {})
  return defaultData
}
const shareClick = function (newData = {}, callback) {
  const defaultData = __getShareData(newData)
  native.shareClick(defaultData, callback)
  return defaultData
}
const setShareWithMask = function (newData = {}, callback) {
  setShare(newData, callback)
  window.__globalBus__.$emit('openShareMask', true)
}

const getShareMiniCode = function (params, w, h, source) {
  return AXIOS.get(`${DomainMaps.appDomain}/zzopen/wxcommon/createCode2Long`, {
    source: source || '134',
    width: w || '500',
    height: h || '500',
    autoColor: 'false',
    lineColor: {
      r: '0',
      g: '0',
      b: '0'
    },
    page: 'pages/webview/bridge',
    params: {
      ...params,
      shareCode: 'true'
    }
  })
}

export { setShare, shareClick, setShareWithMask, setSharePoster, getShareMiniCode }
